import { CodedError } from '../../CodedError';
import { bpErrorsCodes } from '../errorCodes';

export class ChargeCodeSourceRestrictionError extends CodedError {
  static get errorName() {
    return bpErrorsCodes.chargeCodeSourceRestrictionError.name;
  }

  constructor(message = bpErrorsCodes.chargeCodeSourceRestrictionError.message) {
    super(message);
    this.code = bpErrorsCodes.chargeCodeSourceRestrictionError.code;
    this.name = bpErrorsCodes.chargeCodeSourceRestrictionError.name;
  }
}